import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model"

export class CreateExpedienteNotaRequest extends CreateKeyValueRequest {
  public idExpediente!: number
  public idUsuario!: number
}
